import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import TimestampConverter from '../../components/TimestampConverter';

const TimestampConvert: React.FC = () => (
  <ToolLayout
    title="Unix Timestamp Converter - Date to Timestamp | AllTools"
    description="Convert Unix timestamps to human-readable dates and vice versa. Free online timestamp converter."
    canonicalPath="/timestamp-converter"
  >
    <TimestampConverter />
  </ToolLayout>
);

export default TimestampConvert;
